<template>
    <div>
        <zip-insight-window></zip-insight-window>
        <map-panel></map-panel>
    </div>
</template>

<script>
import MapPanel from '../MapPanel'
import ZipInsightWindow from '../Dialogs/ZipInsightWindow'

export default {
  name: 'BodyContainer',
  components: { MapPanel, ZipInsightWindow }
}
</script>



// WEBPACK FOOTER //
// src/components/Containers/BodyContainer.vue